import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'

import { Author } from 'src/app/shared/interfaces/author.interface'
import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { Page } from 'src/app/shared/interfaces/page.interface'
import { WorkingGroup } from 'src/app/shared/interfaces/resources/working-group.interface'
import { StripHtmlPipe } from 'src/app/shared/pipes/strip-html.pipe'
import { AuthorService } from 'src/app/shared/services/author.service'
import { MetaService } from 'src/app/shared/services/meta.service'
import { PageService } from 'src/app/shared/services/page-service/page.service'
import { WorkingGroupService } from 'src/app/shared/services/working-group.service'
import { FlashMessageService } from '../../../../shared/services/flash-message.service'
import { ExpertGroupPortalService } from '../../services/expert-group-portal.service'

@Component({
  selector: 'app-expert-group-portal-expert-list',
  templateUrl: './expert-group-portal-expert-list.component.html',
  styleUrls: ['./expert-group-portal-expert-list.component.scss']
})
export class ExpertGroupPortalExpertListComponent implements OnInit {
  page: Page
  workingGroup: WorkingGroup
  authors: Author[]

  selectedParams: {
    role?: string
    workingGroupId?: string
    terms?: string
    countryId?: string
    stakeholderTypeId?: string
  }

  loading: boolean
  loadingPage: boolean

  baseUrl: string
  expertGroupPortal: ExpertGroupPortal

  constructor(
    private pageService: PageService,
    private workingGroupService: WorkingGroupService,
    private authorService: AuthorService,
    private metaService: MetaService,
    private stripHtmlPipe: StripHtmlPipe,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private expertGroupPortalService: ExpertGroupPortalService,
    private flashMessageService: FlashMessageService
  ) {}

  async ngOnInit() {
    this.loadingPage = true
    // Get the current expert group portal without the query params
    this.baseUrl = await this.router.url.split('?')[0]

    // The id of the current expert group portal, it's always one string before the last slash
    const id: string = this.baseUrl.split('/').slice(-2)[0]

    this.expertGroupPortal =
      await this.expertGroupPortalService.getExpertGroupPortalById(id)

    this.page = await this.pageService.show(
      this.expertGroupPortal.slug + '-experts'
    )
    this.loadingPage = false

    this.activatedRoute.queryParams.subscribe((queryParams: Params) => {
      this.loading = true

      this.workingGroupService
        .showBySlug(this.expertGroupPortal.workingGroupSlug)
        .then((workingGroup: WorkingGroup) => {
          this.workingGroup = workingGroup

          this.selectedParams = {
            role: queryParams?.role || '',
            workingGroupId: this.workingGroup.id.toString(),
            countryId: queryParams?.countryId || '',
            stakeholderTypeId: queryParams?.stakeholderTypeId || '',
            terms: queryParams?.terms || ''
          }
          ;(
            this.authorService.list({
              workingGroup: this.selectedParams.workingGroupId,
              role: this.selectedParams.role,
              country: this.selectedParams.countryId,
              stakeholderType: this.selectedParams.stakeholderTypeId,
              terms: this.selectedParams.terms,
              withoutPagination: true
            }) as Promise<Author[]>
          ).then((authorRes: Author[]) => {
            this.loading = false
            this.authors = authorRes
          })
        })
        .catch(() => {
          this.loading = false
          this.flashMessageService.error(
            'Error loading experts: Working group not found'
          )
        })
    })

    this.metaService.setTags({
      title: this.page.metaTitle || this.page.title,
      description: this.stripHtmlPipe.transform(
        this.page.metaDescription || this.page.excerpt
      ),
      path: this.expertGroupPortal.id + '/experts',
      absoluteOgImage: this.page.image
        ? this.page.image.socialCard ||
          this.page.image.landscape ||
          this.page.image.videoCard
        : this.metaService.defaultMeta.absoluteOgImage
    })
  }
}
